
import { generateQueryParams } from 'utils/interfaces';
import CommonService from './common.service';

class BlogService extends CommonService {
	async getBlog(params?: { [key: string]: string | boolean }) {
		const query = generateQueryParams(params);
		return await this.get(`posts/?${query}`);
	}
	async getBlogDetails(id: string) {
		return await this.get(`posts/${id}`)
	}
	async createBlog(parmas: { [key: string]: boolean | string }) {
		return await this.post('posts', parmas)
	}
	async updateBlog(id: string, params: { [key: string]: boolean | string }) {
		return await this.put(`posts/${id}`, params)
	}
	
	async deleteBlog(id: string) {
		return await this.delete(`posts/${id}`)
	}
}
export const blogService = new BlogService();
